import { makeStyles, shorthands } from "@fluentui/react-components";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { makeDocsLink } from "@tdp/common/constants";
import { Flex } from "@tdp/common/fluentV9MigrationComponents";
import { useCommand, useSelector } from "@tdp/core";

import { appDetailsSlice } from "../../appDetails";
import { AppPublishType } from "../abstractions";
import { AppPageHeader } from "../AppPageHeader";
import { AppValidationHeroCard } from "../overviewWidgets/AppValidationHeroCard";
import { BasicInfo } from "../overviewWidgets/OverviewBasicInfo";
import { OverviewHeroCard } from "../overviewWidgets/OverviewHeroCard";
import { OverviewHeroCardShimmer } from "../overviewWidgets/OverviewHeroCardShimmer";
import { OverviewUsageSummary } from "../overviewWidgets/OverviewUsageSummary";


const useOverviewStyles = makeStyles({
  mediumSize: {
    width: "626px",
    height: "304px",
    ...shorthands.margin("5px")
  },
  smallSize: {
    width: "308px",
    height: "304px",
    ...shorthands.margin("5px")
  },
})

const AppOverview: React.FC = () => {
  const styles = useOverviewStyles();
  const intl = useIntl();
  const { appId } = useParams();
  const app = useSelector((s) =>
    appDetailsSlice.selectors.getAppById(s, appId ?? '')
  );

  const getAppPublishType = useCommand((commands) => commands.analyticsCommands.getAppPublishType);
  const appPublishingType = useSelector((state) => state.appType.appType);

  const manifestAnnoucement = {
    title: intl.formatMessage({
      defaultMessage: "Announcement",
      description: "Title for content groups containing an announcement.",
    }),
    subtitle: intl.formatMessage({ defaultMessage: "Manifest version", description: "appValidationTableManifest" }),
    imgSrc: '/images/illustrations/publish-org.png',
    message: intl.formatMessage({ defaultMessage: "The latest manifest v1.17 supports extending Teams apps with a personal app or message extension across the Microsoft 365 ecosystem (Outlook and Office).", description: "Announcement pertaining to the v1.17 manifest update, which is necessary for an app to be supported across the Microsoft 365 ecosystem." }),
    buttonText: intl.formatMessage({ defaultMessage: "Learn more", description: "Learn more link text without the ellipsis", }),
    action: () => {
      window.open(makeDocsLink("microsoftteams/platform/m365-apps/overview"), "_blank");
    }
  }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!appPublishingType && app?.appId) {
      getAppPublishType({ externalAppId: app.appId });
    }
  }, [appPublishingType, app]);


  return (
    <Flex fill column>
      <AppPageHeader title={intl.formatMessage({ defaultMessage: "Overview", description: "overview" })} />
      <Flex wrap>
        <Flex className={styles.mediumSize}>
          <AppValidationHeroCard />
        </Flex>
        <Flex className={styles.mediumSize}>
          <OverviewHeroCard {...manifestAnnoucement} />
        </Flex>
        <Flex className={styles.mediumSize} style={appPublishingType === AppPublishType.CDN_App ? {} : { height: "402px" }}>
          <BasicInfo />
        </Flex>
        {
          !appPublishingType && <Flex className={styles.mediumSize} style={{ height: "402px" }}>
            <OverviewHeroCardShimmer />
          </Flex>
        }
        {appPublishingType === AppPublishType.CDN_App &&
          <Flex className={styles.mediumSize}>
            <OverviewUsageSummary />
          </Flex>
        }
        {appPublishingType === AppPublishType.TDP_App &&
          <Flex className={styles.mediumSize}>
            {/* <LegacyAppUsage /> */}
          </Flex>
        }
      </Flex>
    </Flex >
  )
}

export default AppOverview;